import React,{ Component, PropTypes } from 'react';

class JoomlaActions extends Component {

  render(){

    return (
      <div>
        
        
      </div>
    )
  }
}

export default JoomlaActions;



// WEBPACK FOOTER //
// ./src/components/JoomlaActions.js